import usePopulateDataLayer from '../../../hooks/usePopulateDataLayer';

//** This is wrapper component to execute usePopulateDataLayer and avoid several rerenders of App.js */
export const PageLoad = () => {
  usePopulateDataLayer();
  return null;
};
